import React from 'react';

import ContentLoader from 'components/utility/ContentLoader/ContentLoader';
import { EntityTypes } from 'context/entityContext';

interface IEntityItemLoaderProps {
  className?: string;
  /** The entityType that we are displaying */
  entityType?: EntityTypes;
}

const EntityItemLoader: React.FC<IEntityItemLoaderProps> = (props) => {
  const { className, entityType } = props;

  const ArtworkShape =
    entityType && ['artist', 'label'].includes(entityType) ? (
      <circle cx="23.5" cy="22.5" r="22.5" />
    ) : (
      <rect width="40.5" height="40.5" x="3.5" y="3.5" />
    );

  return (
    <ContentLoader width={301} height={45} className={className}>
      {ArtworkShape}
      <rect width="210" height="15" x="63" y="3" />
      <rect width="91" height="15" x="63" y="26" />
      <rect width="45" height="15" x="171" y="26" />
      <rect width="68" height="15" x="233" y="26" />
      <circle cx="162.5" cy="34.5" r="2.5" />
      <circle cx="224.5" cy="34.5" r="2.5" />
    </ContentLoader>
  );
};

export default EntityItemLoader;
